class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');
    this.content = this.mainDetailsToggle.querySelector('summary').nextElementSibling;

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('toggle', this.onToggle.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    });
  }

  onToggle() {
    if (!this.animations) this.animations = this.content.getAnimations();

    if (this.mainDetailsToggle.hasAttribute('open')) {
      this.animations.forEach((animation) => animation.play());
    } else {
      this.animations.forEach((animation) => animation.cancel());
    }
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);

class HeaderMenu extends DetailsDisclosure {
  constructor() {
    super();
    this.header = this.closest('.header-wrapper');
    this.hoverMediaQuery = window.matchMedia('(hover: hover) and (pointer: fine)');

    this.querySelectorAll('[data-header-menu-parent-link]').forEach((link) => {
      link.addEventListener('click', (event) => event.stopPropagation());
    });

    if (this.dataset.openBehavior === 'hover') {
      this.addEventListener('mouseenter', this.onMouseEnter.bind(this));
      this.addEventListener('mouseleave', this.onMouseLeave.bind(this));

      this.mainDetailsToggle.querySelectorAll('.header__submenu details').forEach((submenu) => {
        submenu.addEventListener('mouseenter', () => this.openOnHover(submenu));
        submenu.addEventListener('mouseleave', () => this.closeOnHover(submenu));
      });
    }
  }

  onMouseEnter() {
    if (!this.hoverMediaQuery.matches) return;

    clearTimeout(this.hoverCloseTimeout);
    if (this.mainDetailsToggle.classList.contains('mega-menu')) {
      const summary = this.mainDetailsToggle.querySelector('summary');
      const gap = Math.max(0, this.header.getBoundingClientRect().bottom - summary.getBoundingClientRect().bottom);
      this.style.setProperty('--header-menu-hover-gap', `${Math.ceil(gap) + 1}px`);
    }
    this.header.querySelectorAll('header-menu').forEach((menu) => {
      if (menu !== this) menu.close();
    });
    this.mainDetailsToggle.setAttribute('open', '');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', true);
  }

  onMouseLeave() {
    if (!this.hoverMediaQuery.matches) return;

    // Allow the pointer to cross the gap between the trigger and dropdown.
    clearTimeout(this.hoverCloseTimeout);
    this.hoverCloseTimeout = setTimeout(() => this.close(), 300);
  }

  disconnectedCallback() {
    clearTimeout(this.hoverCloseTimeout);
  }

  close() {
    clearTimeout(this.hoverCloseTimeout);
    this.mainDetailsToggle.querySelectorAll('details[open]').forEach((submenu) => {
      submenu.removeAttribute('open');
      submenu.querySelector('summary')?.setAttribute('aria-expanded', false);
    });
    super.close();
  }

  openOnHover(submenu) {
    if (!this.hoverMediaQuery.matches) return;

    submenu.setAttribute('open', '');
    submenu.querySelector('summary')?.setAttribute('aria-expanded', true);
  }

  closeOnHover(submenu) {
    if (!this.hoverMediaQuery.matches) return;

    submenu.removeAttribute('open');
    submenu.querySelector('summary')?.setAttribute('aria-expanded', false);
  }

  onToggle() {
    if (!this.header) return;
    this.header.preventHide = this.mainDetailsToggle.open;

    if (document.documentElement.style.getPropertyValue('--header-bottom-position-desktop') !== '') return;
    document.documentElement.style.setProperty(
      '--header-bottom-position-desktop',
      `${Math.floor(this.header.getBoundingClientRect().bottom)}px`
    );
  }
}

customElements.define('header-menu', HeaderMenu);
